import { TopicPack } from "@/types";

const nsfw: TopicPack = {
  id: "nsfw-vol-1",
  sku: "pack-nsfw-vol-1",
  name: "NSFW Vol. I",
  topics: [
    [
      "69",
      "A Dildo",
      "A Penis",
      "A Vagina",
      "Bag of Dicks",
      "Butthole Waxing",
      "Casual BDSM",
      "Diarrhea",
      "Dirty Jokes",
      "Eurethra",
      "Exhibitionism",
      "Foot Worship",
      "Horny",
      "Humiliation Fetish",
      "Pegging",
      "Poopy Stuff",
      "Porn Comment Section",
      "Public Urination",
      "Sex for the Elderly",
      "Sex with a Peach",
      "Snorting Cocaine",
      "Spanking",
      "Sphincter",
      "Vulgar Language",
    ],
  ],
};

export default nsfw;
